export default __webpack_public_path__ + "static/media/panhanleLogoBlack.7fa29bd1.png";